import type { AvailabilityStatus } from '@psp-aggregator/sdk';

export type ProviderStatusLabelKey = 'status.active' | 'status.paused';

export type ProviderStatusBadgeVariant = 'success' | 'warning';

export const PROVIDER_STATUS_I18N_KEY: Record<
  AvailabilityStatus,
  ProviderStatusLabelKey
> = {
  active: 'status.active',
  paused: 'status.paused',
};

export const PROVIDER_STATUS_BADGE_VARIANT: Record<
  AvailabilityStatus,
  ProviderStatusBadgeVariant
> = {
  active: 'success',
  paused: 'warning',
};

export const PROVIDER_STATUS_FILTER_OPTIONS: readonly AvailabilityStatus[] = [
  'active',
  'paused',
] as const;
